import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Formik } from 'formik'
import * as yup from 'yup'
import to from 'await-catch'
import { restoreAccount } from '../../../api'
import {
	FormContainer,
	BackButton,
	FormHeader,
	FormTitle,
	FormSubtitle,
	InputsContainer,
	ButtonsContainer,
	LinkButton,
	HeaderDesktop,
	HeaderMobile,
	MobileBackButton,
	FormSubtitleBold,
	EmptySpace
} from '../../ui/form'
import Input from '../../ui/input'
import { Button } from '../../ui/button'
import { Container } from './styled'
import theme from '../../../styled/theme'
import { ChevronLeft, ChevronRight } from '../../../assets/icons'
import Feedback from '../../feedback'
import useIsMobile from '../../../hooks/useIsMobile'

const ForgotPassword = () => {
	const initialValues = { email: '' }
	const validationSchema = yup.object().shape({
		email: yup
			.string()
			.email('Email no válido')
			.required('Campo requerido')
	})
	const [messageResult, setMessageResult] = useState(false)
	const [errorResult, setErrorResult] = useState(false)
	const isMobile = useIsMobile();

	const history = useHistory()

	const handleBack = () => {
		history.push('/')
	}

	const handleSubmit = async ({ email }) => {
		const [err] = await to(restoreAccount(email))
		if (!err) {
			setMessageResult(true)
		} else {
			setErrorResult(true)
		}
	}

	if (messageResult) {
		return (
			<Feedback
				title="Te enviamos un correo con las instrucciones"
				bodyText="Recordá revisar la carpeta de correo no deseado."
				onClickButton={handleBack}
			/>
		)
	} else if (errorResult) {
		return (
			<Feedback
				title="Hubo un error al enviar las instrucciones"
				bodyText="Por favor, intentá nuevamente más tarde."
				isError={true}
				onClickButton={handleBack}
			/>
		)
	}

	return (
		<>
			<FormContainer justify="between" justifyMobile={'between'} paddingMobile={'20px 32px 15px 32px'} gap={isMobile ? 20 : 32}>
				<Formik
					initialValues={initialValues}
					validationSchema={validationSchema}
					onSubmit={handleSubmit}
				>
					{({ values, errors, handleChange, handleSubmit }) => (
						<>
							<Container>
								<HeaderDesktop>
									<BackButton onClick={handleBack}>
										<ChevronLeft color={theme.colors.brand.blueOmint} />
										<LinkButton>Volver</LinkButton>
									</BackButton>
								</HeaderDesktop>
								<HeaderMobile>
									<MobileBackButton onClick={handleBack}>
										<ChevronLeft color={theme.colors.black} />
									</MobileBackButton>
									<FormSubtitleBold>Olvidé mi contraseña</FormSubtitleBold>
									<EmptySpace />
								</HeaderMobile>
								<FormHeader align="start" gap={8} mb={0}>
									<FormTitle align="left" mb={0}>
										Recuperar contraseña
									</FormTitle>
									<FormSubtitle align="left">
										Ingresá tu email para recuperar tu contraseña.
									</FormSubtitle>
								</FormHeader>
								<InputsContainer gap={24} mb={16}>
									<Input
										label="Email"
										type="email"
										name="email"
										placeholder="Ingresá tu email"
										value={values.email}
										onChange={handleChange}
										error={errors.email}
										fullWidth
									/>
								</InputsContainer>
							</Container>
							<ButtonsContainer gap={24}>
								<Button
									label="Recuperar"
									$variant="primary"
									size="mobile"
									onClick={handleSubmit}
									disabled={!values.email}
								/>
								<LinkButton onClick={handleBack}>Cancelar</LinkButton>
							</ButtonsContainer>
						</>
					)}
				</Formik>
			</FormContainer>
		</>
	)
}

export default ForgotPassword
